<template>
  <div v-if="this.subscription && this.subscription.plan">
    <div class="container mobile-logo">
      <div class="row">
        <div class="col-md-12">
          <img class="mb-4" src="../../assets/img/gofar-logo-large.webp" width="165" height="35" alt="Logo"
            style="margin-top: 15px" />
        </div>
      </div>
    </div>
    <div class="container-fluid checkout-mobile">
      <div class="container">
        <div class="row checkout">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <table>
              <tbody>
                <tr style="cursor: pointer">
                  <td class="cart-ico">
                    <i class="bi bi-cart3"></i>
                  </td>
                  <td v-on:click="showOrderSummaryInMobile = !showOrderSummaryInMobile;">
                    <span> {{ showOrderSummaryInMobile ? 'Hide' : 'Show'}} Order Summary</span>
                    <i :class="['bi', showOrderSummaryInMobile ? 'bi-chevron-up' : 'bi-chevron-down']" class="bi bi-caret-down-fill"></i>
                  </td>
                  <td class="price">
                    {{ this.countrySetting.currencySymbol
                    }}{{ (this.subscription.grandTotal / 100).toFixed(2) }}
                  </td>
                </tr>
              </tbody>
            </table>

            <AccordionTransition>
              <div v-if="showOrderSummaryInMobile">
                <div style="margin-top: 20px"></div>
                <div id="quantity-picker">
                  <span>Quantity</span> <br />
                  <div class="input-group">
                    <button id="btnDecreaseQuantity" type="button" class="btn btn-primary"
                      v-on:click="decreaseQuantity()">
                      <i class="bi bi-dash"></i>
                    </button>
                    <input type="text" style="text-align: center" class="form-control" disabled
                      v-model="this.subscription.plan.quantity" />
                    <button id="btnIncreaseQuantity" type="button" class="btn btn-primary"
                      v-on:click="increaseQuantity()">
                      <i class="bi bi-plus"></i>
                    </button>
                  </div>
                </div>
                <CheckoutProducts v-if="this.subscription.plan != null" v-bind:plan="this.subscription.plan"
                  v-bind:products="this.products" v-bind:currencySymbol="this.countrySetting.currencySymbol">
                </CheckoutProducts>
                <div class="row discount-form discount-section">
                  <div class="input-group">
                    <input type="text" class="form-control" name="discount" placeholder="Coupon Code"
                      v-model="this.selectedCouponCode" />
                    <button id="btnApplyCoupon"
                      v-on:click="applyCoupon(this.selectedCouponCode, this.selectedPlan, this.selectedProductIds)"
                      class="btn btn-outline-primary" type="button">
                      Apply
                    </button>
                  </div>
                </div>
                <CheckoutCouponNotification v-bind:coupon="this.coupon"></CheckoutCouponNotification>
                <CheckoutReferralNotification v-bind:referral="this.referral"></CheckoutReferralNotification>
                <CheckoutSummary v-bind:subscription="subscription" v-bind:products="products"
                  v-bind:shipment="shipment" v-bind:currencySymbol="this.countrySetting.currencySymbol">
                </CheckoutSummary>
              </div>
            </AccordionTransition>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row checkout">
        <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12">
          <img class="mb-4 desktop-logo" src="../../assets/img/gofar-logo.png" alt="Logo" style="margin-top: 15px" />
          <div class="paypal-box">
            <span class="paypal-heading">Express Checkout</span>
            <button class="paypal-button" v-on:click="goWithPaypal()">
              <img src="../../assets/img/paypal.svg" />
            </button>
            <p class="paypal-message"
              v-if="this.paypalExpress.payment_method && this.paypalExpress.payment_method.reference_id.length > 0">
              Your paypal payment is confirmed. Please, fill up the order details and Process.
            </p>
          </div>
          <div class="separator">
            <div class="line"></div>
            <span style="padding-left: 10px; padding-right: 10px;">OR</span>
            <div class="line"></div>
          </div>
          <h2 class="section-header">Contact Information</h2>
          <form class="checkout-form" v-on:submit.prevent>
            <div class="input-wrapper">
              <input type="text" id="email" name="email" v-model="customer.email" @change="
                this.validate('email');
              this.trackCheckoutEvent();
              " placeholder="Email" :class="['form-control', this.validation.fields.email.valid ? '' : 'is-invalid']" :readonly="this.paypalExpress.payment_method && this.paypalExpress.payment_method.reference_id.length > 0
                  " />
              <small class="text-danger" v-if="!this.validation.fields.email.valid">{{ this.validation.fields.email.msg }}</small>
            </div>

            <h2 class="section-header">Shipping Address</h2>
            <div class="row">
              <div class="col-lg-6">
                <div class="input-wrapper">
                  <input id="firstName" autocapitalize="off" spellcheck="false" @change="this.validate('firstName')"
                    v-model="customer.firstName" type="text" name="firstName" :class="['form-control', this.validation.fields.firstName.valid ? '' : 'is-invalid']"
                    placeholder="First Name" />
                  <small class="text-danger" v-if="!this.validation.fields.firstName.valid">{{
                    this.validation.fields.firstName.msg
                    }}</small>
                </div>

              </div>
              <div class="col-lg-6">
                <div class="input-wrapper">
                  <input id="lastName" autocapitalize="off" spellcheck="false" @change="
                    this.validate('lastName');
                  this.updateKlaviyoDetail();
                  " v-model="customer.lastName" type="text" :class="['form-control', this.validation.fields.lastName.valid ? '' : 'is-invalid']" name="lastName"
                    placeholder="Last Name" />
                  <small class="text-danger" v-if="!this.validation.fields.lastName.valid">{{
                    this.validation.fields.lastName.msg
                    }}</small>
                </div>

              </div>
            </div>
            <div class="input-wrapper">
              <input id="companyName" autocapitalize="off" spellcheck="false" v-model="customer.companyName" type="text" name="company"
                class="form-control" placeholder="Company (Optional)" />
            </div>
            <div class="input-wrapper">
              <input autocapitalize="off" spellcheck="false" v-model="customer.address"
                @change="this.validate('address')" type="text" name="address" :class="['form-control', this.validation.fields.address.valid ? '' : 'is-invalid']"
                placeholder="Address" />
              <small class="text-danger" v-if="!this.validation.fields.address.valid">{{ this.validation.fields.address.msg }}</small>
            </div>

            <div class="input-wrapper">
              <input id="apartment" autocapitalize="off" spellcheck="false" v-model="customer.apartment"
                @change="this.validate('apartment')" type="text" name="apartment" class="form-control"
                placeholder="Apartment, Suite, etc. (Optional)" />
            </div>
            <div class="row">
              <div id="country" :class="['col-sm-12', showStates ? 'col-lg-6 col-md-6' : 'col-lg-12 col-md-12']">
                <div class="input-wrapper">
                  <select id="country" name="country" v-model="customer.country" @change="countryChange()" :class="['form-control', this.validation.fields.country.valid ? '' : 'is-invalid']">
                    <option value="">Select Country</option>
                    <option :key="country.code" v-for="country in this.countries" v-bind:value="country.code">{{ country.name }}</option>
                  </select>
                  <small class="text-danger" v-if="!this.validation.fields.country.valid">{{
                    this.validation.fields.country.msg
                    }}</small>
                </div>

              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="input-wrapper" v-if="this.showStates">
                  <select id="stateCode" name="stateCode" v-model="customer.stateCode" @change="stateChange()" :class="['form-control', this.validation.fields.stateCode.valid ? '' : 'is-invalid']">
                    <option value="" selected>Select State</option>
                    <option :key="code" v-for="(name, code) in this.states" v-bind:value="code">{{ name }}</option>
                  </select>
                  <small class="text-danger" v-if="!this.validation.fields.stateCode.valid">{{
                    this.validation.fields.stateCode.msg
                    }}</small>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="input-wrapper" v-if="customer.country !== 'AU'">
                  <input id ="city" autocapitalize="off" spellcheck="false" @change="this.validate('city')" v-model="customer.city"
                    type="text" name="city" :class="['form-control', this.validation.fields.city.valid ? '' : 'is-invalid']" placeholder="City" />
                  <small class="text-danger" v-if="!this.validation.fields.city.valid">{{ this.validation.fields.city.msg }}</small>
                </div>

                <div class="input-wrapper" v-if="customer.country === 'AU'">
                  <input id ="suburb" autocapitalize="off" spellcheck="false" v-model="customer.suburb"
                    @change="this.validate('suburb')" type="text" :class="['form-control', this.validation.fields.suburb.valid ? '' : 'is-invalid']" name="suburb"
                    placeholder="Suburb" />
                  <small class="text-danger" v-if="!this.validation.fields.suburb.valid">{{ this.validation.fields.suburb.msg }}</small>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-wrapper">
                  <input id="postalCode" autocapitalize="off" spellcheck="false" @change="this.validate('postalCode')"
                    v-model="customer.postalCode" type="text" :class="['form-control', this.validation.fields.postalCode.valid ? '' : 'is-invalid']" name="postalCode"
                    placeholder="Postal Code" />
                  <small class="text-danger" v-if="!this.validation.fields.postalCode.valid">{{
                    this.validation.fields.postalCode.msg
                    }}</small>
                </div>
              </div>
            </div>

            <div class="input-wrapper">
              <div :class="['input-group', this.validation.fields.phone.valid ? '' : 'is-invalid']">
        <input id="phone" type="tel" name="phone" @change="this.validate('phone')" v-model="customer.phone" class="form-control"
                 placeholder="Phone" />
        <select v-model="phoneCountryCode" style="max-width: 120px; border-left: none;" class="form-control input-group-append" @change="onCountryChange">
            <option v-for="country in countries" :key="country.code" :value="country.code"
                class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2 px-3">
                {{ country.flag }} {{ country.code }} (+{{ country.dialCode }})
            </option>
        </select>
    </div>
              
              <small class="text-danger" v-if="!this.validation.fields.phone.valid">{{ this.validation.fields.phone.msg }}</small>
              <!-- <PhoneInput v-model="customer.phone"></PhoneInput> -->
            </div>
            <!-- Shipping -->
            <div v-if="this.shipment != null">
              <h2 class="section-header">Shipping Method</h2>
              <ul class="list-group">
                <li :key="shippingOption.id" v-for="shippingOption in this.shippingOptions" class="list-group-item">
                  <div class="row">
                    <div class="col col-8">
                      <input type="radio" class="form-check-input" name="shipment-option"
                        v-bind:value="shippingOption.id" v-model="selectedShippingId" @change="changeShipment"
                        :checked="shippingOption.id == selectedShippingId" />&nbsp; <strong>{{ shippingOption.name
                        }}</strong> <br />
                      <span style="font-size: 12px; padding-left: 20px">
                        {{ shippingOption.delivery_days }} Business Days.
                        {{ shippingOption.has_tracking ? 'Tracked.' : 'No Tracking.' }}
                      </span>
                    </div>
                    <div class="col col-4" style="float: right; text-align: right">
                      <!--
                      This is a temporary hack for our customers to offer free priority shipping that we would normally charge them $10.
                      For now, the price in chargebee has also been set to 0 which matches with the price in constants.js for the shipment.
                      This UI is a hack of showing them that they are getting discount.
                    -->
                      <span
                        v-if="shippingOption.id != 'shipping-australia-post-express' && shippingOption.price === 0">FREE</span>
                      <span v-if="shippingOption.id === 'shipping-australia-post-express'">
                        <span style="text-decoration-line: line-through;">$10</span>&nbsp;FREE TODAY
                      </span>
                      <span v-if="shippingOption.id != 'shipping-australia-post-express' && shippingOption.price > 0">
                        {{ this.countrySetting.currencySymbol }}{{ Number(shippingOption.price / 100).toFixed(2) }}
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- Payment -->
            <div v-show="!this.paypalExpress.payment_method ||
              !this.paypalExpress.payment_method.reference_id ||
              this.paypalExpress.payment_method.reference_id.length === 0
              ">
              <h2 class="section-header">Payment Information</h2>
              <small>All transactions are secure and encrypted.</small>
              <div class="payment-box">
                <div class="row">
                  <small class="paypal-message" v-if="
                    this.paypalExpress.payment_method &&
                    this.paypalExpress.payment_method.reference_id?.length > 0
                  ">You already paid with PayPal so no need to type your card details.</small>
                </div>
                <div class="row">
                  <div id="stripe-payment-errors"></div>
                </div>
                <div class="row">
                  <div id="stripe-payment-element" ref="stripePaymentElementContainer" style="margin-bottom: 0px;">
                  </div>
                </div>
              </div>

            </div>
            <div class="row" style="margin-top: 20px;">
              <div class="col-md-12">
                <div class="input-wrapper"> <button class="btn-process-order" :disabled="this.isProcesingOrder"
                    type="submit" v-on:click="processOrder()">Pay Now</button>
                </div>
              </div>
            </div>
          </form>
          <br />
          <br />
          <br />
          <div class="clear:both; margin: 10px;"></div>
          <CheckoutFooter></CheckoutFooter>
        </div>
        <div class="col-xl-1 col-lg-1 col-md-12 col-sm-12"></div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 checkout-right-panel">
          <div id="quantity-picker">
            <span>Quantity</span> <br />
            <div class="input-group">
              <button id="btnDecreaseQuantity" type="button" class="btn btn-primary" v-on:click="decreaseQuantity()">
                <i class="bi bi-dash-lg"></i>
              </button>
              <input type="text" class="form-control text-center" disabled v-model="this.subscription.plan.quantity" />
              <button id="btnIncreaseQuantity" type="button" class="btn btn-primary" v-on:click="increaseQuantity()">
                <i class="bi bi-plus-lg"></i>
              </button>
            </div>
          </div>
          <CheckoutProducts v-if="this.subscription.plan !== null" v-bind:plan="this.subscription.plan"
            v-bind:products="this.products" v-bind:currencySymbol="this.countrySetting.currencySymbol">
          </CheckoutProducts>

          <div class="row discount-form discount-section">
            <div class="input-group">
              <input type="text" class="form-control" name="discount" placeholder="Coupon Code"
                v-model="this.selectedCouponCode" />
              <button id="btnApplyCoupon"
                v-on:click="applyCoupon(this.selectedCouponCode, this.selectedPlan, this.selectedProductIds)"
                class="btn btn-outline-primary" type="button">
                Apply
              </button>
            </div>
          </div>
          <CheckoutCouponNotification v-bind:coupon="this.coupon"></CheckoutCouponNotification>
          <CheckoutReferralNotification v-bind:referral="this.referral"></CheckoutReferralNotification>
          <CheckoutSummary v-bind:subscription="this.subscription" v-bind:products="this.products"
            v-bind:shipment="this.shipment" v-bind:currencySymbol="this.countrySetting.currencySymbol">
          </CheckoutSummary>
        </div>
      </div>
    </div>
  </div>
  <div v-if="!this.subscription || !this.subscription.plan"></div>
</template>
<script>
import { facade, filter, InputFacade } from 'vue-input-facade';
import Swal from 'sweetalert2';
import { loadStripe } from '@stripe/stripe-js';
import { gofarService } from '../../helpers/gofar-service';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator';
import { HTTP_METHODS, HTTP_STATUS_CODES, PAYMENTS, DEFAULT_SUBSCRIPTION_PLAN } from '../../helpers/config';
import * as chargebeeCheckout from '../../helpers/chargebee-checkout';
import { COUNTRIES, STATES } from '../../helpers/data/address-data-provider';
import * as helper from '../../helpers/helper';
import { spinnerOff, spinnerOn } from '../../helpers/animations';
import CheckoutProducts from './components/CheckoutProducts.vue';
import CheckoutSummary from './components/CheckoutSummary.vue';
import CheckoutFooter from './components/CheckoutFooter.vue';
import CheckoutCouponNotification from './components/CheckoutCouponNotification.vue';
import CheckoutReferralNotification from './components/CheckoutReferralNotification.vue';
import { MAX_ALLOWED_QUANTITY } from '../../helpers/constants';
import AccordionTransition from './components/AccordionTransition.vue'
import PhoneInput from './components/PhoneInput.vue';

export default {
  name: 'CheckoutForm',
  components: {
    CheckoutSummary,
    CheckoutFooter,
    InputFacade,
    CheckoutProducts,
    CheckoutCouponNotification,
    CheckoutReferralNotification,
    AccordionTransition,
    PhoneInput
  },
  directives: { facade },
  filters: { facade: filter },
  data() {
    return {
      countries: COUNTRIES,
      states: STATES,
      showOrderSummaryInMobile: false,
      selectedPlan: '',
      selectedProductIds: [],
      selectedQuantity: 1,
      selectedCouponCode: '',
      countrySetting: null,
      shippingOptions: [],
      showStates: false,
      referral: null,
      checkoutId: '',
      checkoutUrl: '',
      checkoutItems: [],
      selectedShippingId: '',
      // disables the button to prevent multiple clicks when the user might confused the lag with not clicking and try clicking multiple times
      // causing multiple payments in a single checkout
      isProcesingOrder: false,
      products: [],
      shipment: {
        id: '',
        name: '',
        price: 0.0
      },
      subscription: {
        plan: null,
        coupon: null,
        quantity: 1,
        subTotal: 0.0,
        originalSubTotal: 0.0,
        grandTotal: 0.0
      },
      coupon: {
        code: '',
        discount_type: '',
        discount_amount: 0,
        apply_on: '', // invoice_amount | each_specified_item
        item_constraints: [],
        isValid: false,
        message: ''
      },
      customer: {
        email: '',
        firstName: '',
        lastName: '',
        companyName: '',
        address: '',
        apartment: '',
        stateCode: '',
        postalCode: '',
        suburb: '',
        city: '',
        country: '',
        currencyCode: '',
        phone: ''
      },
      phoneCountryCode: '',
      validation: {
        fields: {
          // set fields valid to be true to avoid displaying error message when page loads
          // fields definitions are placed according to the order of their display so that right element gets highlighted and focused when there is validation error
          email: { valid: true, msg: 'Enter an Email' },
          firstName: { valid: true, msg: 'Enter a First name' },
          lastName: { valid: true, msg: 'Enter a Last name' },
          address: { valid: true, msg: 'Enter an Address' },
          country: { valid: true, msg: 'Select a Country' },
          stateCode: { valid: true, msg: 'Select a State' },
          suburb: { valid: true, msg: 'Enter a Suburb' },
          city: { valid: true, msg: 'Enter a City' },
          postalCode: { valid: true, msg: 'Enter a ZIP / Postal code' },
          phone: { valid: true, msg: 'Enter a Phone number' },
        },
        errors: []
      },
      paypalExpress: {
        payment_method: {
          type: 'paypal_express_checkout',
          reference_id: '',
          token: ''
        }
      },
      stripeClient: null,
      stripeElements: null
    };
  },
  async created() {
    this.selectedPlan = this.$route.query.plan || DEFAULT_SUBSCRIPTION_PLAN;
    this.selectedProductIds = this.$route.query.products ? this.$route.query.products.split(',') : [];
    this.selectedCouponCode = this.$route.query.coupon_code || '';
    this.customer.country = this.$route.query.country_code ? this.$route.query.country_code.toUpperCase() : 'AU';
    this.phoneCountryCode = this.customer.country;
    this.selectedQuantity = Math.ceil(Math.abs(this.$route.query.quantity)) || 1;
    this.states = STATES[this.customer.country];
    this.showStates = Object.keys(STATES).includes(this.customer.country);
    this.checkoutId = this.$route.query.checkout_id || '';
    this.countrySetting = helper.getCountrySetting(this.customer.country);
    this.shippingOptions = this.countrySetting.shippingOptions;
    this.coupon = await chargebeeCheckout.validateCouponCode(
      this.selectedCouponCode,
      this.selectedPlan,
      this.selectedProductIds
    );
    this.referral = {
      code:
        this.$route.query.referral_code && this.$route.query.referral_code.length > 5
          ? this.$route.query.referral_code.substr(0, 5)
          : '',
      type:
        this.$route.query.referral_code && this.$route.query.referral_code.length > 5
          ? this.$route.query.referral_code.slice(-1)
          : '',
      referrer: this.$route.query.referrer || ''
    };
    this.products = this.generateProducts();
    this.selectedShippingId = chargebeeCheckout.getDefaultShipmentOption(this.countrySetting).id;
    this.shipment = this.calculateShipment();
    // better to have it calculated at the end after everything because of its dependency
    this.subscription = this.generateSubscription();
    if (process.env.VUE_APP_ENV !== 'test') {
      this.mountPaypal(this.countrySetting.currencyCode);
    }
  },
  async mounted() {
    if (process.env.VUE_APP_ENV !== 'test') {
      this.stripeClient = await loadStripe(PAYMENTS.STRIPE);
      const paymentElementOptions = {
        mode: 'payment',
        // stripe needs currency code to be in lower case
        currency: this.countrySetting.currencyCode.toLowerCase(),
        amount: 100,
        setup_future_usage: 'off_session',
        capture_method: 'manual'
      };
      const appearance = {
        theme: 'night',
      };

      const stripeMounter = () => {
        try {
          this.stripeElements = this.stripeClient.elements(paymentElementOptions, appearance);
          // we want our customers to fill card number, expiry date and cvv only
          // country and postalcode is collected as part of shipping information and they are used to fill in confirmPayment method
          // please check confirmPayment
          const stripeElementOptions = {
            layout: {
              type: 'accordion',
              defaultCollapsed: false,
              radios: true,
              spacedAccordionItems: false
            },
            fields: {
              billingDetails: {
                address: {
                  country: 'never',
                  postalCode: 'never'
                }
              }
            },
            terms: {
              card: 'never',
              applePay: 'never',
              googlePay: 'never'
            },
            wallets: {
              applePay: 'auto',
              googlePay: 'auto',
              link: 'never'
            }
          };
          this.paymentElement = this.stripeElements.create('payment', stripeElementOptions);
          this.paymentElement.mount("#stripe-payment-element");
          clearInterval(tryMount);
        } catch (err) {
          console.log(err);
          // do nothing just try again finally it will be mounted.
        }
      };
      const tryMount = setInterval(stripeMounter, 100);
    }
  },
  methods: {
    calculateShipment() {
      // shipping is required only when the order includes adapter / ray (actual hardware to be delivered) not when only plan is selected
      return this.selectedProductIds.length > 0 ? chargebeeCheckout.mapToSelectedShippingOption(this.countrySetting, this.selectedShippingId) : null;
    },
    generateSubscription() {
      const subscription = chargebeeCheckout.mapToSubscriptionCheckout(
        this.selectedPlan,
        this.products,
        this.coupon,
        this.countrySetting,
        this.selectedQuantity,
        this.shipment
      );
      return subscription;
    },
    generateProducts() {
      const products = chargebeeCheckout.mapToSubscriptionProducts(
        this.selectedProductIds,
        this.countrySetting,
        this.coupon,
        this.selectedQuantity,
        this.selectedPlan
      );
      return products;
    },
    validate: function (fieldName) {
      if (!this.validation.fields[fieldName]) {
        return;
      }
      if (fieldName === 'stateCode') {
        const states = STATES[this.customer.country];
        const countryHasStates = states && Object.keys(states).length > 0;
        this.validation.fields[fieldName].valid = !(countryHasStates && !this.customer[fieldName]);
      } else if (fieldName === 'suburb') {
        if (this.customer.country === 'AU') {
          this.validation.fields[fieldName].valid = this.customer[fieldName] && this.customer[fieldName].length > 0 && this.customer[fieldName].trim().length > 0;
        } else {
          this.validation.fields[fieldName].valid = true;
        }
      } else if (fieldName === 'city') {
        if (this.customer.country != 'AU') {
          this.validation.fields[fieldName].valid = this.customer[fieldName] && this.customer[fieldName].length > 0 && this.customer[fieldName].trim().length > 0;
        } else {
          this.validation.fields[fieldName].valid = true;
        }
      } else if (fieldName === 'email' && this.customer[fieldName].length > 0 && this.customer[fieldName].trim().length > 0) {
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const isValidEmailFormat = emailRegex.test(this.customer[fieldName]);
        this.validation.fields[fieldName].valid = isValidEmailFormat;
        this.validation.fields[fieldName].msg = isValidEmailFormat ? 'Enter an Email': 'Enter a valid Email';
      }
      else if (fieldName==='phone' && this.customer[fieldName].length > 0 && this.customer[fieldName].trim().length > 0){
        const isValidPhone = isValidPhoneNumber(this.customer[fieldName], this.phoneCountryCode);
        this.validation.fields[fieldName].valid = isValidPhone
        this.validation.fields[fieldName].msg = isValidPhone ? 'Enter a Phone number': 'Enter a valid Phone number';
      }
      else if (fieldName==='postalCode' && this.customer[fieldName].length > 0 && this.customer[fieldName].trim().length > 0){
        const isValidPostCode = postcodeValidatorExistsForCountry(this.customer.country) && postcodeValidator(this.customer[fieldName], this.customer.country);
        this.validation.fields[fieldName].valid =  isValidPostCode;
        this.validation.fields[fieldName].msg = isValidPostCode ? 'Enter a ZIP / Postal code': 'Enter a valid ZIP / Postal code';
      }
      else {
        this.validation.fields[fieldName].valid =
          this.customer[fieldName] && this.customer[fieldName].length > 0 && this.customer[fieldName].trim().length > 0;
      }
    },
    validateForm: function () {
      this.validation.errors = [];
      for (const fieldName of Object.keys(this.validation.fields)) {
        this.validate(fieldName);
        if(!this.validation.fields[fieldName].valid){
          this.validation.errors.push({
            fieldName,
            msg: this.validation.fields[fieldName].msg
          });
        }
      }
    },
    trackCheckoutEvent: function () {
      if (
        this.customer['email'] &&
        this.validation.fields['email'].valid &&
        !this.checkoutId &&
        !this.$route.query.checkout_id
      ) {
        const today = new Date();
        const checkoutId = `${today.getFullYear()}${today.getMonth()}${today.getDate()}${today.getHours()}${today.getMinutes()}${today.getSeconds()}${today.getMilliseconds()}`;
        this.checkoutId = checkoutId;
        const checkoutUrl = `${process.env.VUE_APP_CHECKOUT_URL}?products=${this.$route.query.products}&plan=${this.selectedPlan}&coupon_code=${this.coupon.code}&referral_code=${this.referral.code}${this.referral.type}&referrer=${this.referral.referrer}&quantity=${this.subscription.quantity}&checkout_id=${checkoutId}`;
        this.checkoutUrl = checkoutUrl;
        this.setCheckoutItems();
        if (process.env.VUE_APP_ENV === 'production' && klaviyo) {
          try {
            klaviyo.identify({ $email: this.customer['email'] });
            setTimeout(() => {
              klaviyo.push([
                'track',
                'Started Checkout',
                {
                  CheckoutUrl: this.checkoutUrl,
                  CheckoutProducts: this.checkoutItems
                }
              ]);
            }, 1000);
          } catch (err) {
            // fail silently
          }
        }
      }
    },
    updateKlaviyoDetail: function () {
      try {
        this.pushToKlaviyo([
          'identify',
          {
            $email: this.customer['email'],
            $first_name: this.customer['firstName'],
            $last_name: this.customer['lastName'],
            CheckoutUrl: this.checkoutUrl,
            CheckoutProducts: this.checkoutItems
          }
        ]);
      } catch (err) {
        // fail silently
      }
    },
    pushToKlaviyo: function (data) {
      if (process.env.VUE_APP_ENV === 'production' && klaviyo) {
        klaviyo.push(data);
      }
    },
    setCheckoutItems: function () {
      const itemNames = this.products.map((product) => product.name);
      const productsAndPlan = [...itemNames, this.subscription.plan.name];
      this.checkoutItems = [...productsAndPlan];
    },
    countryChange: function (isPrefilled = false) {
      if (!isPrefilled) {
        this.customer.stateCode = '';
      }
      this.showStates = Object.keys(STATES).includes(this.customer.country);
      this.states = STATES[this.customer.country];
      this.countrySetting = helper.getCountrySetting(this.customer.country);
      this.shippingOptions = this.countrySetting.shippingOptions;
      this.selectedShippingId = chargebeeCheckout.getDefaultShipmentOption(this.countrySetting).id;
      this.shipment = this.calculateShipment();
      this.products = this.generateProducts();
      // needs to have shipment calculation first before calculating subscription
      this.subscription = this.generateSubscription();
      // todo: check why we are not validating country in the beginning of country change event
      this.validate('country');
      if (this.stripeElements) {
        this.stripeElements.update({ currency: this.countrySetting.currencyCode.toLowerCase() });
      }
    },
    stateChange: function () {
      if (this.customer.country && this.customer.stateCode) {
        this.customer.state = STATES[this.customer.country][this.customer.stateCode];
      }
      this.validate('stateCode');
    },
    changeShipment: function () {
      this.shipment = this.calculateShipment();
      this.subscription = this.generateSubscription();
    },
    mountPaypal: function () {
      if (process.env.VUE_APP_ENV !== 'test') {
        let paypal = document.createElement('script');
        paypal.setAttribute(
          'src',
          `https://www.paypal.com/sdk/js?client-id=${PAYMENTS.PAYPAL_MERCHANT_ID}&currency=${this.countrySetting.currencyCode}`
        );
        document.head.appendChild(paypal);
      }
    },
    goWithPaypal: function () {
      window.dataLayer.push({
        event: 'paypal_start'
      });
      var paypalWindow = window.open(
        `${process.env.VUE_APP_GOFAR_SERVICE_URL}/api/checkout/paypal?currency=${this.countrySetting.currencyCode}`,
        'GOFAR - Paypal'
      );

      window.addEventListener(
        'message',
        async (e) => {
          if (e.origin.includes(process.env.VUE_APP_GOFAR_SERVICE_URL)) {
            this.paypalExpress.payment_method.reference_id = decodeURI(e.data.billingAgreementId);
            this.paypalExpress.payment_method.token = e.data.token;
            paypalWindow.close();
            const result = await chargebeeCheckout.fetchPaypalCustomerDetail(e.data.token, this.customer);
            this.customer = result;
            this.paypalExpress.payment_method.payerStatus = result.payerStatus;
            this.countryChange(true);
            this.validateForm();
            window.dataLayer.push({
              event: 'paypal_finished'
            });
          }
        },
        false
      );
    },
    applyCoupon: async function (couponCode, selectedPlan) {
      spinnerOn();
      // sequence is important here, it is important to have coupon validated first
      this.coupon = await chargebeeCheckout.validateCouponCode(couponCode, selectedPlan, this.selectedProductIds);
      this.products = this.generateProducts();
      this.subscription = this.generateSubscription();
      window.dataLayer.push({
        couponCode,
        event: 'coupon_applied'
      });
      spinnerOff();
    },
    increaseQuantity: function () {
      let quantity = parseInt(this.subscription.plan.quantity, 10);
      quantity = quantity === MAX_ALLOWED_QUANTITY ? MAX_ALLOWED_QUANTITY : (quantity += 1);
      this.selectedQuantity = quantity;
      this.products = this.generateProducts();
      this.subscription = this.generateSubscription();
    },
    decreaseQuantity: function () {
      let quantity = parseInt(this.subscription.plan.quantity, 10);
      quantity = quantity === 1 ? 1 : (quantity -= 1);
      this.selectedQuantity = quantity;
      this.products = this.generateProducts();
      this.subscription = this.generateSubscription();
    },
    processStripePayment: async function () {
      try {
        // Step 1 - Create payment intent
        const stripeResponse = await gofarService('/api/checkout/stripe/create-payment-intent', HTTP_METHODS.POST, {
          /**
           * make sure that the grand total adds up to the total cost of plan, products (add-ons) and shipping cost (shipping items are actually add-on in chargebee)
           * if the grandtotal payment made in stripe doesn't add up then it won't create subscription in chargebee due to amount difference
           */
          amount: this.subscription.grandTotal,
          currency: this.countrySetting.currencyCode,
          email: this.customer.email,
          firstName: this.customer.firstName,
          lastName: this.customer.lastName
        });
        if (stripeResponse.data.error) {
          return {
            error: {
              message: stripeResponse.data.error
            }
          }
        }

        const clientSecret = stripeResponse.data.client_secret;


        const { error: submitError } = await this.stripeElements.submit();
        if (submitError) {
          return {
            error: {
              message: stripeResponse.data.error
            }
          }
        }

        // Step 2 - Confirm card payment
        const confirmPaymentResponse = await this.stripeClient.confirmPayment({
          elements: this.stripeElements,
          clientSecret,
          redirect: 'if_required',
          confirmParams: {
            return_url: process.env.VUE_APP_CHECKOUT_URL,
            payment_method_data: {
              billing_details: {
                address: {
                  country: this.customer.country,
                  postal_code: this.customer.postalCode
                }
              }
            }
          }
        });
        return confirmPaymentResponse;
      } catch (err) {
        throw err;
      }
    },
    processOrder: async function () {
      try {
        this.validateForm();
        if (this.validation.errors.length > 0) {
          const domId = this.validation.errors[0].fieldName;
          const domElem = document.getElementById(domId);
          domElem.scrollIntoView({ behavior: 'smooth' });
          domElem.focus();
          return;
        }
        this.isProcesingOrder = true;
        spinnerOn();
        let paymentData = {};
        let payment = {};
        // user has not used paypal
        if (!this.paypalExpress.payment_method || this.paypalExpress.payment_method.reference_id.length === 0) {
          // authenticate for stripe payment
          payment = await this.processStripePayment();
          if (payment.error) {
            Swal.fire({
              confirmButtonColor: '#0093dc',
              icon: 'error',
              title: 'Card Details Error',
              html: `Oops! We could not process your payment.<br/>${payment.error.message}`,
              footer: `Please contact us at support@gofar.co to resolve the issue.`
            });
            return;
          }
          if (payment.paymentIntent && payment.paymentIntent.status !== 'requires_capture') {
            throw new Error(payment);
          } else {
            // successfully authenticated stripe payment
            paymentData = {
              gw_token: payment.paymentIntent.id,
              gateway_account_id: process.env.VUE_APP_STRIPE_GW
            };
            // remove paypal express info if user pays by stripe
            this.paypalExpress = {};
          }
        }
        const subscriptionPayload = await chargebeeCheckout.mapToChargebeeSubscriptionRequestPayloadV2(
          this.customer,
          this.subscription,
          this.products,
          this.coupon,
          this.shipment,
          paymentData,
          this.referral,
          this.paypalExpress
        );
        const subscription_result = await gofarService(
          '/api/checkout/v2/chargebee/subscription',
          HTTP_METHODS.POST,
          subscriptionPayload
        );
        if (subscription_result.status !== HTTP_STATUS_CODES.SUCCESS) {
          Swal.fire({
            icon: 'error',
            confirmButtonColor: '#0093dc',
            title: 'Order Process Fail',
            html: `Oops! We could not process your order.<br/>${subscription_result.data.error}`,
            footer: `Please contact us at support@gofar.co with the error message above to resolve the issue.`
          });
          if (payment.paymentIntent) {
            // cancel the payment that is hold on card immediately if we fail to create subscription in chargebee
            await gofarService(`/api/checkout/stripe/cancel-payment-intent?id=${payment.paymentIntent.id}`, 'POST');
          }
        } else {
          // data set in local storage he will be used in checkout finish page for tracking in GA
          localStorage.setItem('chargebee_subscription', JSON.stringify(subscription_result.data));
          localStorage.setItem('subscription', JSON.stringify(this.subscription));
          localStorage.setItem('products', JSON.stringify(this.products));
          localStorage.setItem('customer', JSON.stringify(this.customer));
          localStorage.setItem('shipment', JSON.stringify(this.shipment));
          localStorage.setItem('referral', JSON.stringify(this.referral));
          localStorage.setItem('coupon_code', this.coupon.code);
          try {
            this.pushToKlaviyo(['track', 'Placed Order']);
          } catch (err) {
            // silently fail klaviyo event tracking error
          }
          this.$router.push({
            path: '/checkout-finish',
            query: { order_id: subscription_result.data.subscription.id }
          });
        }
      } catch (err) {
        Swal.fire({
          confirmButtonColor: '#0093dc',
          icon: 'error',
          title: 'Order Process Fail',
          html: `Oops! We could not process your Order.<br/>Please contact us at support@gofar.co.`,
          footer: `Please provide the details below to us: <br/> ${err}`
        });
      } finally {
        this.isProcesingOrder = false;
        spinnerOff();
      }
    }
  }
};
</script>
